module.exports = __webpack_public_path__ + "img/index07.f9f84ad0.svg";